import type { Asset } from '@spine-workspace/shared';

export type SortField = 'name' | 'type' | 'date' | 'size';
export type SortDir = 'asc' | 'desc';

export function sortAssets(assets: Asset[], field: SortField, dir: SortDir): Asset[] {
  return [...assets].sort((a, b) => {
    let cmp = 0;
    switch (field) {
      case 'name': cmp = a.name.localeCompare(b.name); break;
      case 'type': cmp = (a.spineVersion ?? '').localeCompare(b.spineVersion ?? ''); break;
      case 'date': cmp = new Date(a.createdAt ?? 0).getTime() - new Date(b.createdAt ?? 0).getTime(); break;
      case 'size': cmp = (a.fileSize ?? 0) - (b.fileSize ?? 0); break;
    }
    return dir === 'asc' ? cmp : -cmp;
  });
}

export function groupAssetsByType(assets: Asset[]): { label: string; items: Asset[] }[] {
  const spine = assets.filter((a) => a.spineVersion !== 'image');
  const image = assets.filter((a) => a.spineVersion === 'image');
  const result: { label: string; items: Asset[] }[] = [];
  if (spine.length > 0) result.push({ label: 'Spine', items: spine });
  if (image.length > 0) result.push({ label: 'Images', items: image });
  return result;
}
